import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../../partials/LoadingSpinner';
import { H4, Panel, Box, Text, Button, Badge } from '@bigcommerce/big-design';
import { CloudUploadIcon } from '@bigcommerce/big-design-icons';

import { uploadThresholds } from '../../../redux/actions/thresholds';

const ThresholdUpload = ({ payload, activeAddress, thresholds, upload }) => {
  const [submitted, setSubmitted] = useState(false);
  const [file, setFile] = useState();
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    if(e.target.files[0]) {
      setSubmitted(false);

      if(e.target.files[0].size <= 1048576) {
        setError(null);
        setFile(e.target.files[0]);
      } else {
        setError('File size is too large (max size 1MB).');
        setFile(null);
      }

    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (file !== undefined && !file.cancelled && file.name) {
      upload(payload, file, activeAddress.id);
    }
  }

  return(
    <Panel>
      <Box
        backgroundColor="primary10"
        border="box"
        borderRadius="normal"
        padding="medium"
      >
        <a target="_blank" href="https://athousandapps.com/bigcommerce/upload-suggestion-thresholds-csv/">
          Read more about the expected CSV file format and generating a CSV from BigCommerce
        </a>
      </Box>

      <H4>Upload Inventory Thresholds CSV:</H4>
      <div className="muted">
        Supported file types: csv
      </div>
      <form onChange={ (e) => handleChange(e) } onSubmit={ (e) => handleSubmit(e) }>
        <input type="file" name="file" accept="text/plain, .csv" />
        <br/>
        <br/>
        <Button iconLeft={<CloudUploadIcon />} disabled={submitted || !file}>
          Upload Inventory Thresholds CSV
        </Button>
      </form>
      <br/>
      <br/>
      { thresholds.uploadStatus !== 'waiting' &&  
        <Box
          backgroundColor={ thresholds.uploadStatus === 'failure' ? 'danger20' : 'primary10'}
          border="box"
          borderRadius="normal"
          padding="medium"
        >
          { thresholds.uploadStatus === 'failure' &&
            <Text>
              An error occurred while uploading or processing this CSV. Please reach out to support@athousandapps.com if you need help.
            </Text>
          }

          { thresholds.uploadStatus === 'processing' &&
            <Text>
              CSV is processing. View your location's thresholds to see creation results. If errors occur, we'll reach out to see if they can be resolved!
            </Text>
          }

          { thresholds.uploadStatus === 'uploading' &&
            <Text>
              Uploading CSV...
            </Text>
          }

          { thresholds.uploadStatus === 'uploaded' &&
            <Text>
              CSV successfully uploaded! Starting processing...
            </Text>
          }

          { thresholds.uploadStatus === 'processing_requested' &&
            <Text>
              CSV successfully uploaded! Processing requested...
            </Text>
          }
        </Box>
      }
    
    </Panel>
  )
}

const mapStateToProps = state => ({
  thresholds: state.thresholds,
});

const mapDispatchToProps = (dispatch) => ({
  upload: (payload, file, locationId) => dispatch(uploadThresholds(payload, file, locationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ThresholdUpload);